/* ПРОДОЛЖИТСЯ ЧЕРЕЗ ВРЕМЯ С НОВОЙ ЗАДАЧЕЙ ЭТОТ ШАГ */

import React from 'react';
import { useT } from 'talkr';
import common from '../../index.module.scss';
import s from './index.module.scss';

import blockIcon2 from './img/infoBlock_icon_2.png';

function InfoBlock (props) {
	return (
		<section className={`${s.item} ${props.class}`} style={{ backgroundImage: props.cover }}>
			<h2 className={s.itemTitle}>{props.name}</h2>
			<div className={s.itemDescription}>{props.description}</div>
			<img src={props.icon} className={s.itemIcon} alt={props.name} />
		</section>
	);
}

function ResultPageStep () {
	const { T } = useT();
	const blocks = [
		{
			name: 'Fitness',
			description: T('result_page_step_fitness_description'),
			class: s.fitness,
			icon: blockIcon2
		},
		{
			name: 'Nutrition',
			description: T('result_page_step_nutrition_description'),
			class: s.fitness,
			icon: blockIcon2
		},
		{
			name: 'Walking',
			description: T('result_page_step_walking_description'),
			class: s.fitness,
			icon: blockIcon2
		},
		{
			name: 'Sleep',
			description: T('result_page_step_sleep_description'),
			class: s.fitness,
			icon: blockIcon2
		}
	];

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>{T('result_page_step_title')}</h1>
			<div className={common.stepDescription}>{T('result_page_step_title_description')}</div>
			<ul className={s.items}>
				{blocks.map((item, index) => (
					<li className={s.itemWrapper} key={item.name}>
						<InfoBlock
							class={item.class}
							name={item.name}
							description={item.description}
							icon={item.icon}
							number={index}
						/>
					</li>
				))}
			</ul>
		</div>
	);
}

export default ResultPageStep;
